import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.span`
	font-size: 1.6rem;
	letter-spacing: 3px;
	background: #fad000;
	padding: 0.5rem 1.1rem;
	position: absolute;
	top: 0;
	font-family: monospace !important;
	color: #4e4e4e;

	${rmq('ml')} {
		font-size: 1.3rem;
	}
`;
